import { configuration } from "@faire/web/common/settings/declarations/configuration";

export enum REAL_TIME_OWF_BUCKET_OVERRIDE {
  NONE = "NONE",
  APPROVE = "APPROVE",
  REJECT = "REJECT",
}

/**
 * Setting to override REAL_TIME_OWF setting for test purposes
 */
export const FE_REAL_TIME_OWF_OVERRIDE_250623 = configuration({
  name: "FE_REAL_TIME_OWF_OVERRIDE_250623",
  defaultValue: REAL_TIME_OWF_BUCKET_OVERRIDE.NONE,
  identifier: "RetailerTokenInSession",
  client: ["RETAILER", "VISITOR_WEB"],
  productArea: "RETAILER_ONBOARDING",
  notifyAfter: "2025-09-23",
});
